import { Component } from '@angular/core';
import { THashComponent } from '../t-hash/t-hash.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-t-find-hash',
  templateUrl: './t-find-hash.component.html',
  styleUrls: ['./t-find-hash.component.css']
})
export class TFindHashComponent extends THashComponent {

  included: boolean = true;
  requiredElement: any = undefined;

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute, protected http: HttpClient) {
    super(topicService, activatedRoute, http);
    this.type="findHash";
    this.title = this.get("findHash");
   }

   setInformationWithConfiguration(){
     super.setInformationWithConfiguration();
     this.requiredElement = this.configuration.typespecifics.requiredElement;
     this.included = this.elements.includes(this.requiredElement);
   }
   
   reset(){
     super.reset();
     this.title = this.get("findHash");
     this.requiredElement = undefined;
     this.included = true;
   }

   /** generate the elements*/
  generateElements() {
    this.count = Math.floor(this.count);
    if(Number.isNaN(this.count)){
      this.count = undefined;
    }
    this.length = Math.floor(this.length);
    if(this.requiredElement){
      this.requiredElement = this.requiredElement.toString().trim();
    }
    if(this.elementType == 'number'){
      this.requiredElement = +this.requiredElement;
      if(Number.isNaN(this.requiredElement)){
        this.requiredElement = undefined;
      }
    }
    if (this.definitionForm.controls['elements'].valid &&
      (this.elementType != "number" ||
        (this.definitionForm.controls['length'].valid))) {
      this.elements=[];
      this.computeElements();
      if(this.elements.includes(this.requiredElement)){
        if(!this.included){
          this.elements.splice(this.elements.indexOf(this.requiredElement), 1);
        }
      } else {
        if(this.included){
          this.elements.push(this.requiredElement);
        }
      }
    }
  }

  generateDefinition(): any {
    let definition = super.generateDefinition();
    definition.typespecifics.requiredElement = this.requiredElement;
    definition.typespecifics.included = this.included;
    definition.image = "./assets/images/findHash.png";
    return definition;
  }

  generate(){
    super.generate();
    this.title = this.get("findHash");
    this.included =  Math.random() > 0.2;
    this.hashElements = false;
   
  
    if(this.included){
      this.requiredElement = this.elements[Math.floor(Math.random() * this.elements.length)];
    } else {
      this.requiredElement = this.elements[0];
      let words = this.text.text.replace(/[.,!:*+?^${}()|[\]\\]/g, "").split(" ").filter(v => v.length > 2).filter(v => v.length < 7);
      words = Array.from(new Set(words));
      while(!this.elements.includes(this.requiredElement)){
        if(this.elementType=="number"){
          this.requiredElement = "";
          for (var j = 0; j < this.length; j++) {
            this.requiredElement = this.requiredElement.concat(Math.floor(Math.random() * 10).toString());
          }
        } else {
          
          this.requiredElement = words[Math.floor(Math.random() * words.length)];
        }
      }
    }
  }

  /** recompute the required element */
  changeRequired(){
    this.requiredElement = this.requiredElement.toString().trim();
    if(this.elementType == 'number'){
      this.requiredElement = Math.floor(this.requiredElement);
    }
  }

}
